export const PREFERENCES_DB_NAME = 'scalar:preferences';
export const PREFERENCES_DB_VERSION = 1;
export const PREFERENCES_STORE_NAME = 'entries';
export const PREFERENCES_FALLBACK_STORAGE_PREFIX = 'scalar:preference:';
export const PREFERENCES_BROADCAST_CHANNEL = 'scalar:preferences';
